export enum SessionStorageKeys {
  ASYNCAPI_LAST_RELOAD = 'asyncapiLastReload',
}

export class SessionStorageHelper {
  static getItem<T>(key: SessionStorageKeys | string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  static setItem<T>(key: SessionStorageKeys | string, value: T): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  static removeItem(key: SessionStorageKeys | string): void {
    sessionStorage.removeItem(key);
  }
}
